import { FileService } from '../../../../shared/middleware/services/FileService';
import { asyncStorage } from '../../../../shared/services/storage/asyncStorageService';
import logger from '../../../../shared/services/logging/logger';

const AUTOMATION_FOLDER = 'Automation Scripts';
const METADATA_FILE     = 'script_metadata.json';

const ScriptMetadataService = {
  /**
   * Read the shared metadata JSON for all automation scripts.
   * projectName must be passed (e.g. project.name from the component).
   * Returns {} if the file doesn't exist yet or on any error.
   */
  async getMetadata(projectId, projectName, userData) {
    try {
      const filePath = `${projectName}/${AUTOMATION_FOLDER}/${METADATA_FILE}`;
      const result   = await FileService.getFileContent(projectId, filePath, userData);
      const raw      = result?.decodedContent;
      if (!raw) return {};
      return typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch {
      return {};
    }
  },

  /**
   * After steps are saved, persist the step types for this script.
   * Project name is read from session/async storage (set by TestSuiteMainPage on navigation).
   * Called fire-and-forget — never throws.
   */
  async updateScriptStepTypes(projectId, scriptName, steps, userData) {
    try {
      const projectName =
        sessionStorage.getItem('currentProjectName') ||
        asyncStorage.get('currentProjectName');

      if (!projectName) {
        logger.warn('ScriptMetadata: project name not found in storage, skipping update');
        return;
      }

      const normalise = t => t === 'mobile' ? 'Mobile' : t;
      const stepTypes   = [...new Set(steps.map(s => s.stepType).filter(Boolean).map(normalise))];
      const folderPath  = `${projectName}/${AUTOMATION_FOLDER}`;
      const current     = await this.getMetadata(projectId, projectName, userData);
      const updated     = { ...current, [scriptName]: stepTypes };

      const file = new File(
        [new Blob([JSON.stringify(updated, null, 2)], { type: 'application/json' })],
        METADATA_FILE,
        { type: 'application/json' }
      );

      await FileService.uploadFile(projectId, folderPath, file, userData);
      logger.debug('ScriptMetadata updated', { scriptName, stepTypes });
    } catch (err) {
      logger.warn('Could not update script metadata', { error: err.message });
    }
  },
};

export default ScriptMetadataService;
